// = Libs =
import * as Yup from 'yup';

// = Constants =
import { MESSAGES, VALIDATION } from '@/components/form/form.constants';

// = Types =
import { CreatePollForm, PeriodicitySelect } from './new-poll.types';

const INITIAL_VALUES: CreatePollForm = {
  author: '',
  title: '',
  description: '',
  periodicType: 'disable',
  startDate: null,
  finishDate: null,
  executors: [],
  isPublic: false,
};

const VALIDATION_SCHEMA = Yup.object().shape({
  author: VALIDATION.required_string(MESSAGES.required),
  title: VALIDATION.required_string(MESSAGES.required),
  description: VALIDATION.string,
  periodicType: VALIDATION.required_string(MESSAGES.required),
  startDate: VALIDATION.required_date(MESSAGES.required),
  finishDate: VALIDATION.required_date(MESSAGES.required),
});

const PERIODICITY_OPTIONS: PeriodicitySelect[] = [
  { value: 'disable', label: 'Единоразовый' },
  { value: 'weekly', label: 'Еженедельный' },
  { value: 'monthly', label: 'Ежемесячный' },
];

export { INITIAL_VALUES, VALIDATION_SCHEMA, PERIODICITY_OPTIONS };
